import React, { PureComponent } from 'react';
import Tab from 'react-bootstrap/Tab';
import { Helmet } from 'react-helmet';
import { SELECTION_EVENT, trackUserEvent } from 'userActivityMiddleware';
import PageTitleBar from 'components/PageTitleBar';
import TabView from 'components/TabView';
import { LG_BREAKPOINT_AND_UP } from 'utils/constants';
import withMediaQuery from 'utils/withMediaQuery';
import AuctionsIcon from 'resources/FeatureIcons/Button-Auctions.svg';
import AuctionsCompleted from './Completed';
import AuctionsLobby from './Lobby';
import './Auctions.css';

const LOBBY_TAB = 'auctions-lobby';
const PAST_AUCTIONS = 'past-auctions';

const TABS = [
  { key: LOBBY_TAB, title: 'Lobby' },
  { key: PAST_AUCTIONS, title: 'Past Auctions' }
];

class AuctionsPage extends PureComponent {
  constructor(props) {
    super(props);

    this.handleTabSelect = this.handleTabSelect.bind(this);
  }

  handleTabSelect(selectedTab) {
    trackUserEvent({
      activityType: SELECTION_EVENT,
      eventName: 'select-auction-tab',
      eventValue: selectedTab,
      initiator: 'auction-tabs'
    });
  }

  render() {
    return (
      <div className="auctions-container">
        <Helmet>
          <title>Auctions</title>
        </Helmet>
        <PageTitleBar title="Auctions" icon={AuctionsIcon} />
        <h1 className="sr-only">Auctions</h1>
        <div className="auctions-window">
          <div className="auctions-list">
            <TabView
              defaultTab={LOBBY_TAB}
              tabTitles={TABS}
              id="auctions-navigation"
              className="auctions-list-tab-view"
              theme="auctions"
              navClassName="auctions-tabs"
              dropdownClassName="auctions-list-menu"
              matchesBreakpoint={this.props.matchesBreakpoint}
              onSelectTab={this.handleTabSelect}
            >
              <Tab.Content>
                <Tab.Pane eventKey={LOBBY_TAB} mountOnEnter>
                  <AuctionsLobby />
                </Tab.Pane>
                <Tab.Pane eventKey={PAST_AUCTIONS} mountOnEnter>
                  <AuctionsCompleted />
                </Tab.Pane>
              </Tab.Content>
            </TabView>
          </div>
        </div>
      </div>
    );
  }
}

const AuctionsPageWithMediaQuery =
  withMediaQuery(LG_BREAKPOINT_AND_UP)(AuctionsPage);

export default AuctionsPageWithMediaQuery;
